<script>
import RedactorControl from '../RedactorControl.vue';

export default {
    components: {
        RedactorControl
    },

    props: {
        index: {
            type: Number,
            required: true
        },
        interviewQuestion: {
            type: Object,
            required: true
        },
        parentQuestions: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        },
    },

    data() {
        return {
            isTriggered: Boolean(this.interviewQuestion.parent_id)
        }
    },
    methods: {
        removeHtmlTags(htmlString) {
            const tmp = document.createElement('DIV');
            tmp.innerHTML = htmlString;
            return tmp.textContent || tmp.innerText || '';
        }
     }
}
</script>

<template>
    <div>
        <input v-if="interviewQuestion.id" :name="`interview_questions[${index}][id]`" type="hidden" required :value="interviewQuestion.id" />
        <div class="grid-x grid-padding-x mb-3">
            <div class="cell small-12">
                <label class="mb-2">Question</label>

                <div class="grid-x grid-padding-x">
                    <div class="cell auto">
                        <input v-if="disabled" :disabled="disabled" :name="`interview_questions[${index}][title]`" type="text" required v-model="interviewQuestion.title" />
                        <RedactorControl v-if="!disabled"
                            :name="`interview_questions[${index}][title]`"
                            :value="(interviewQuestion) ? interviewQuestion.title : ''"
                            rows="5"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x mb-3 pl-40">
            <div class="cell small-5 pl-0 pr-2">
                <label>Question Phase:</label>

                <select :disabled="disabled" :name="`interview_questions[${index}][phase]`" required v-model="interviewQuestion.phase">
                    <option value="First Interview">First Interview</option>
                    <option value="Panel Interview">Panel Interview</option>
                    <option value="Telephonic Screening">Telephonic Screening</option>
                </select>
            </div>

            <div class="cell small-5 pl-4 pr-2">
                <label>Answer Type:</label>

                <select :disabled="disabled" :name="`interview_questions[${index}][answer_type]`" required v-model="interviewQuestion.answer_type">
                    <option value="free">Free words / explain / discuss</option>
                    <option value="rating">Rating (1-5)</option>
                    <option value="yes_no">Yes / No</option>
                </select>
            </div>
            <div class="cell small-2 pt-25 pl-0">
                <div v-if="!disabled" @click="() => $emit('remove')" class="remove-button"><i class="fas fa-minus-circle"></i></div>
            </div>
        </div>
        <div class="grid-x grid-padding-x mb-4 pl-40">
            <div v-if="parentQuestions.length > 0" class="cell pl-0 small-12">
                <div class="form-check form-check-inline form-check-reverse">
                    <input  v-model="isTriggered" :disabled="disabled" class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                    <label class="form-check-label" for="inlineCheckbox1">Is Triggered Question?</label>
                </div>
            </div>

            <div v-if="isTriggered" class="cell small-12">
                <div class="grid-x grid-padding-x">
                    <div class="cell small-6">
                        <label>Parent Question:</label>

                        <select :disabled="disabled" :name="`interview_questions[${index}][parent_id]`" required v-model="interviewQuestion.parent_id">
                            <option v-for="question in parentQuestions" :value="question.id" :key="`${question.id}-parent`">
                                {{ removeHtmlTags(question.title) }}
                            </option>
                        </select>
                    </div>

                    <div class="cell small-6">
                        <label>Answer:</label>

                        <select :disabled="disabled" :name="`interview_questions[${index}][parent_answer]`" required v-model="interviewQuestion.parent_answer">
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                        </select>
                    </div>
                </div>
            </div>
            <input v-else :name="`interview_questions[${index}][parent_id]`" type="hidden" value="" />

            <div v-if="! interviewQuestion.id" class="cell help-text mt-1">
                <small>* You'll need to save progress before being able to use this as a trigger question.</small>
            </div>
        </div>
    </div>
</template>

<style scoped>
.help-text {
    font-size: 12px;
}
</style>